import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddPaymentLayer from "../components/AddPaymentLayer";

const AddPaymentPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Add Purchase Payment" />
        <AddPaymentLayer />
      </MasterLayout>
    </>
  );
};

export default AddPaymentPage;
